import React from 'react'
import { Button, Modal } from 'react-bootstrap'

const ConfirmationModal = ({show,message, setShow,onConfirm, data}) => {
    // console.log(data);

    const handleClose = () => setShow(false);

    return (
        <Modal show={show} onHide={handleClose} centered>
            <Modal.Header closeButton>
                {/* <Modal.Title>Delete Appointment </Modal.Title> */}
            </Modal.Header>
            <Modal.Body>
                <h6>{message}</h6>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="primary" onClick={onConfirm}>
                    Yes! i'm sure
                </Button>
                <Button variant="secondary" onClick={handleClose}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    )
}

export default ConfirmationModal
